export type ExperimentStatusDictionary = {
    [key: string]: boolean;
};

// Define a list of experiments that are running in SPA.
// The value for each experiment has to match the experiment name defined
// in Experiment Access Control on server side
export enum ExperimentType {
    // Action Planner
    CheckmarkAndFilter = 'ActionPlannerExp2',
    ActionAssigner = 'ActionPlannerExp3',
    ActionDueDate = 'ActionPlannerExp4',
    TakeawaysActionPlanner = 'ProductScience-ActionPlannerExp5-TakeawaysActionPlanner',
    ActionRating = 'GPI-ActionPlannerExp6-ActionRanking',
    // Hire Painted Doors
    JobAlignment = 'HirePDExp1',
    CustomJobListing = 'HirePDExp2',
    CandidatePoolStats = 'HirePDExp3',
    LaunchDarklyDemo = 'LDDemo'
}
